import React, { useEffect, useState } from "react";
import api from "../services/api"; // Your API service

const EditProfilePage = () => {
    const [formData, setFormData] = useState({
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
    });

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [isEditing, setIsEditing] = useState(false); // Controls edit mode

    useEffect(() => {
        const fetchUserProfile = async () => {
            try {
                const response = await api.get("/user-edit/profile");
                setFormData(response.data);
            } catch (err) {
                console.error("Error fetching profile:", err);
                setError("Failed to load profile.");
            } finally {
                setLoading(false);
            }
        };

        fetchUserProfile();
    }, []);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setSuccess(null);

        try {
            const response = await api.put("/user-edit/profile", formData);
            setSuccess(response.data.message);
            setIsEditing(false); // Exit edit mode after saving
        } catch (err) {
            console.error("Error updating profile:", err);
            setError("Failed to update profile.");
        }
    };

    if (loading) return <p>Loading...</p>;
    if (error) return <p style={{ color: "red" }}>{error}</p>;

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                {/* Edit Icon (only shows in view mode) */}
                {!isEditing && (
                    <span style={styles.editIcon} onClick={() => setIsEditing(true)}>
                        ✏️
                    </span>
                )}

                <h5 style={{textAlign:'center'}}>Profile</h5>

                

                {isEditing ? (
                    // Editable Form
                    <form onSubmit={handleSubmit} style={styles.form}>
                        <label>First Name:</label>
                        <input type="text" name="first_name" value={formData.first_name} onChange={handleChange} required />

                        <label>Last Name:</label>
                        <input type="text" name="last_name" value={formData.last_name} onChange={handleChange} required />

                        <label>Email:</label>
                        <input type="email" name="email" value={formData.email} onChange={handleChange} required />

                        <label>Phone:</label>
                        <input type="tel" name="phone" value={formData.phone} onChange={handleChange} required />

                        <button type="submit" style={styles.saveButton}>Save Changes</button>
                        <button type="button" onClick={() => setIsEditing(false)} style={styles.cancelButton}>
                            Cancel
                        </button>
                        {error && <p style={styles.error}>{error}</p>}
                    </form>
                ) : (
                    // View Mode
                    <div>
                        <p><strong>First Name:</strong> {formData.first_name}</p>
                        <p><strong>Last Name:</strong> {formData.last_name}</p>
                        <p><strong>Email:</strong> {formData.email}</p>
                        <p><strong>Phone:</strong> {formData.phone}</p>
                    </div>
                   
                )}
                {success && <p style={styles.success}>{success}</p>}
            </div>
        </div>
    );
};

// Styles
const styles = {
    container: {
        maxWidth: "400px",
        margin: "50px auto",
        padding: "20px",
        fontFamily: "Arial, sans-serif",
    },
    card: {
        position: "relative",
        padding: "20px",
        border: "1px solid #ddd",
        borderRadius: "8px",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
        backgroundColor: "#fff",
    },
    editIcon: {
        position: "absolute",
        top: "10px",
        right: "10px",
        fontSize: "20px",
        cursor: "pointer",
        color: "#007bff",
        transition: "color 0.2s ease-in-out",
    },
    form: {
        display: "flex",
        flexDirection: "column",
    },
    error: {
        color: "red",
        fontSize: "14px",
        marginBottom: "10px",
    },
    success: {
        color: "green",
        fontSize: "14px",
        marginBottom: "10px",
    },
    cancelButton: {
        marginTop: "10px",
        backgroundColor: "red",
        border: "none",
        padding: "10px",
        cursor: "pointer",
        color:'white',
    },
    saveButton: {
        marginTop: "10px",
        backgroundColor: "#45a049",
        border: "none",
        padding: "10px",
        cursor: "pointer",
        color:'white',
    }
};

export default EditProfilePage;
